export interface FormError {
  id: string;
  message: string;
  extraMessage?: string;
}

export enum SubmitStatusEnum {
  IDLE = 'idle',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export interface SubmitStatus {
  loading: boolean;
  submitted: SubmitStatusEnum;
  message: string;
}

export interface DateObjectType {
  day: string;
  month: string;
  year: string;
}
